(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-op-track]');
    var prevBtn = root.querySelector('[data-op-prev]');
    var nextBtn = root.querySelector('[data-op-next]');

    if (!track) return;

    var circles = Array.prototype.slice.call(track.querySelectorAll('.op-circle'));
    if (circles.length === 0) return;

    /* While a smooth-scroll animation from a click is still running, the
       track's scrollLeft is mid-flight. A second click before it settles
       would read that in-between position as "current", then jump to a
       neighboring index computed from it — landing on a spot that isn't
       aligned with any circle and visually slices one in half. Lock input
       until the animation is done. */
    var isAnimating = false;
    var settleTimer = null;

    /* Position of a circle's left edge relative to the track's scrollable
       content — independent of offsetParent, so it stays correct no matter
       what positions the ancestor chain. */
    function circleOffset(circle) {
      return circle.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    /* Index of the first circle at (or just past) the current scroll
       position — recomputed fresh from actual layout each time, so clicks
       never drift out of alignment. */
    function currentIndex() {
      for (var i = 0; i < circles.length; i++) {
        if (circleOffset(circles[i]) >= track.scrollLeft - 2) return i;
      }
      return circles.length - 1;
    }

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.hidden = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.hidden = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;
    }

    function onSettled() {
      isAnimating = false;
      updateArrows();
    }

    function goToIndex(index) {
      index = Math.max(0, Math.min(circles.length - 1, index));
      isAnimating = true;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(onSettled, 500);
      track.scrollTo({ left: circleOffset(circles[index]), behavior: 'smooth' });
    }

    function step(direction) {
      if (isAnimating) return;
      goToIndex(currentIndex() + direction);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { step(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { step(1); });
    }

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', onSettled);
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    updateArrows();
  }

  document.querySelectorAll('[data-op-slider]').forEach(initSlider);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-op-slider]').forEach(initSlider);
  });
})();
